// src/stores/guideStore.ts
// Zustand store for guide page — enables "Run in Codemate" flow

import { create } from 'zustand';

interface GuideState {
  // Pending prompt from "Run in Codemate" button
  pendingPrompt: string | null;
  // Which target: 'chat' | 'bookmate' | 'workflow'
  pendingTarget: 'chat' | 'bookmate' | 'workflow' | null;

  // Active learning path state
  activePath: string | null;
  activeLevel: number | null;

  // Actions
  setPendingPrompt: (prompt: string, target: 'chat' | 'bookmate' | 'workflow') => void;
  consumePendingPrompt: () => { prompt: string; target: string } | null;
  setActivePath: (path: string | null) => void;
  setActiveLevel: (level: number | null) => void;
  clearGuide: () => void;
}

export const useGuideStore = create<GuideState>((set, get) => ({
  pendingPrompt: null,
  pendingTarget: null,
  activePath: null,
  activeLevel: null,

  setPendingPrompt: (prompt, target) =>
    set({ pendingPrompt: prompt, pendingTarget: target }),

  // Read and clear in one operation — prevents double consumption
  consumePendingPrompt: () => {
    const { pendingPrompt, pendingTarget } = get();
    if (pendingPrompt && pendingTarget) {
      set({ pendingPrompt: null, pendingTarget: null });
      return { prompt: pendingPrompt, target: pendingTarget };
    }
    return null;
  },

  setActivePath: (path) => set({ activePath: path }),
  setActiveLevel: (level) => set({ activeLevel: level }),

  clearGuide: () =>
    set({
      pendingPrompt: null,
      pendingTarget: null,
      activePath: null,
      activeLevel: null,
    }),
}));
